import { Component, OnInit, OnDestroy, Inject, ViewChild, ElementRef } from '@angular/core';
import { YearService } from '../../../../shared-components/year/year.service';
import { UserPreferencesService } from '../../../../shared-components/user-preferences/user-preferences.service';
import { SchoolYearSettings } from '../../../../shared-components/year/school-year-settings.model';
import { ReportingService } from '../../reporting.service';
import { LoginService } from '../../../../shared-modules/login/login.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CourseTerm } from '../../../../student360/student-schedule/course-term.model';
import { ReportV9 } from '../../models/report-v9.model';
import { ErrorList } from '../../../../shared-components/controls/error-prompt/error-list.model';
import { StudentAttachment } from '../../../student-attachment/student-attachment.model';
import { System } from '../../../../shared-components/System';
import { ReportQueueComponent } from '../../report-queue/report-queue.component';
import { ReportParameterV9 } from '../../models/report-parameter-v9.model';
import { User } from '../../../../shared-components/user/user.model';
import { UserService } from '../../../../shared-components/user/user.service';


@Component({
    selector: 'class-list-all',
    templateUrl: './class-list-all.component.html',
    styleUrls: ['./class-list-all.component.css'],
})
export class ClassListAllComponent implements OnInit, OnDestroy {
    schoolYearSettings: SchoolYearSettings;
    userPreferences: any;
    currentUser: User;
    reportParameter = new ReportParameterV9();
    thisDialogRef: MatDialogRef<ClassListAllComponent>;
    term: CourseTerm;
    report: ReportV9;
    ErrorCount: 0;
    parameters = [];
    param = [];
    // ERROR HANDLING
    // form: Form;
    errors: ErrorList[] = [];
    public numberMask = {};
    teacherUserId = 0;
    // @ViewChild('Week1Date', { read: ElementRef }) week1Date: ElementRef;
    // @ViewChild('Week2Date', { read: ElementRef }) week2Date: ElementRef;
    @ViewChild('Select', { read: ElementRef }) select: ElementRef;
    // @ViewChild('FromPeriod', { read: ElementRef }) fromPeriod: ElementRef;
    // @ViewChild('ToPeriod', { read: ElementRef }) toPeriod: ElementRef;
    isDataExist = false;
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        ClassListAllDialogRef: MatDialogRef<ClassListAllComponent>,
        private dialog: MatDialog,
        private loginService: LoginService,
        private yearService: YearService,
        private userPreferencesService: UserPreferencesService,
        private reportingService: ReportingService,
        private userService: UserService,
    ) {
        this.thisDialogRef = ClassListAllDialogRef;
        this.report = data.Report;
    }

    ngOnInit() {

        this.reportParameter.ReportTitle = 'Class List - All';
        this.reportParameter.PrintDate = new Date().toISOString().substring(0, 10);
        this.numberMask = this.reportingService.getNumberMask();
        this.currentUser = this.userService.currentUser;
        // this.getUserPreferences(); // no preferences for this report in DTO so I commented this for now
        this.getSchoolYearSettings();
        // this.getDynamicPagesReadForStudentLookup();

    }
    ngOnDestroy() {

    }

    getUser() {

        this.loginService.getUser()
    }
    getSchoolYearSettings() {
        this.yearService.getSchoolYearSettings(this.yearService.defaultYear.Id, this.yearService.defaultYear.SchoolID).subscribe(data => {
            this.schoolYearSettings = data;
            this.reportParameter.isValueChange = false;
            this.reportParameter.isReportList = false;
            // this.setReportTitle();
            this.reportParameter.TermId = -1;
        });
    }
    getUserPreferences() {
        this.userPreferencesService.getUserPreferences(0, '/ClassListAll.aspx').subscribe(results => {
            this.userPreferences = JSON.parse(results[0]);
            if (this.userPreferences != null) {
                this.reportParameter.ReportTitle = this.userPreferences.ReportTitle;
                this.reportParameter.PrintDate = this.userPreferences.PrintDate;
            }

        });
    }

    getDynamicPagesReadForStudentLookup() {
        this.reportingService.getDynamicPagesReadForStudentLookup(false).subscribe(results => {
            this.reportParameter.OtherFields = results;
            if (results.length > 0) {
                this.reportParameter.OtherField = results[0].Id;
                if (this.userPreferences != null) {
                    if (this.userPreferences.pub_strOtherField != '') {
                        this.reportParameter.OtherField = this.userPreferences.pub_strOtherField.toString();
                    }
                }
            }
        });
    }
    // setReportTitle() {
    //     if (this.loginService.LoginSettings.State != 'CA') {
    //         if (moment(this.reportParameter.Week1Date).isValid() && moment(this.reportParameter.Week2Date).isValid()) {
    //             this.reportParameter.ReportTitle = 'Weeks of: ' + moment.utc(this.reportParameter.Week1Date).format('MM/DD/YYYY') + ' and ' + moment.utc(this.reportParameter.Week2Date).format('MM/DD/YYYY');
    //         }
    //     } else {
    //         this.reportParameter.ReportTitle = 'Attendance Roster Verification';
    //     }
    // }

    changeValue() {
        this.reportParameter.isValueChange = true;
        if (this.reportParameter.FromPeriod > this.schoolYearSettings.MaximumPeriodsPerDay || this.reportParameter.FromPeriod < this.schoolYearSettings.MinumumPeriodPerDay) {
            this.reportParameter.FromPeriod = this.schoolYearSettings.MinumumPeriodPerDay;
        }
        if (this.reportParameter.ToPeriod > this.schoolYearSettings.MaximumPeriodsPerDay || this.reportParameter.ToPeriod < this.schoolYearSettings.MinumumPeriodPerDay) {
            this.reportParameter.ToPeriod = this.schoolYearSettings.MaximumPeriodsPerDay;
        }
    }
    cancelShowReportParameters() {
        this.thisDialogRef.close();
    }


    runClick() {

        this.errors = [];
        if (typeof this.reportParameter.ReportTitle == 'undefined') {
            this.errors.push({
                fieldName: 'Title',
                errorMsg: '<span><a style="cursor:pointer;text-decoration:underline;text-wrap:none;white-space: nowrap;"></a>  Please add a Report Title!<span>',
                fieldRef: null
            });
        }
        if (typeof this.reportParameter.PrintDate == 'undefined') {
            this.errors.push({
                fieldName: 'Date',
                errorMsg: '<span><a style="cursor:pointer;text-decoration:underline;text-wrap:none;white-space: nowrap;"></a>  Please add a Report Date!<span>',
                fieldRef: null
            });
        }

        if (this.errors.length == 0) {



            const workflowReport = false;

            // if user is teacher then set Id
            if (this.currentUser.UserIsTeacher) {
                this.teacherUserId = this.currentUser.Id;
            }

            // this.saveUserPreferences();
            this.parameters = [];
            this.param = [];
            this.param.push({ ParamName: 'strReportDate', ParamStringValue: this.reportParameter.PrintDate });
            this.param.push({ ParamName: 'strReportSiteHeader', ParamStringValue: this.yearService.defaultYear.SchoolName });
            this.param.push({ ParamName: 'strReportTitle', ParamStringValue: this.reportParameter.ReportTitle });
            this.param.push({ ParamName: 'strSiteYearCode', ParamStringValue: this.yearService.defaultYear.SchoolCode + '' + this.yearService.defaultYear.AYIdentifier });
            this.param.push({ ParamName: 'strReportOutputFile', ParamStringValue: 'NOFILE' });
            this.param.push({ ParamName: 'lngSiteYearId', ParamStringValue: this.yearService.defaultYear.SiteYearId });
            this.param.push({ ParamName: 'lngTeacherUserId', ParamStringValue: this.teacherUserId });
            this.param.push({ ParamName: 'bytStartPeriod', ParamStringValue: '0' });
            this.param.push({ ParamName: 'bytEndPeriod', ParamStringValue: '12' });
            this.param.push({ ParamName: 'blnOnlyUnMarked', ParamStringValue: false }); // not sure if this needs to be passed
            this.param.push({ ParamName: 'intSortOrder', ParamStringValue: 3 });


            this.parameters.push(JSON.stringify(this.param));
            if (workflowReport) {
                this.reportingService.runV9Report(this.report.ReportName, this.report.ReportType, workflowReport, this.parameters).subscribe(response => {
                    setTimeout(() => {
                        this.reportQueueList();
                    }, 500);
                }
                    , err => {
                        // On Error
                        console.log(err);
                    });
            } else {
                const studentAttachment: StudentAttachment = {
                    DocumentId: 0,
                    DocumentName: this.report.ReportName,
                    DocumentBase64: '',
                    DocumentMimeType: '',
                    DocumentModuleName: '',
                    ReportParameters: this.parameters,
                    ReportType: this.report.ReportType
                };
                window.localStorage.setItem('studentAttachment', JSON.stringify(studentAttachment));
                window.open(System.baseUrl + 'studentattachment', '_blank');
            }
            this.thisDialogRef.close();
        }
    }

    saveUserPreferences() {
        const UserPreferencesObj = this.userPreferences;
        UserPreferencesObj.pub_blnPrintNoField = (this.reportParameter.radValue == 'radNoField' ? true : false);
        UserPreferencesObj.pub_blnPrintStudentId = (this.reportParameter.radValue == 'radPrintStudentID' ? true : false);
        UserPreferencesObj.pub_blnPrintOtherField = (this.reportParameter.radValue == 'radOtherField' ? true : false);
        if (this.reportParameter.OtherField != '') {
            UserPreferencesObj.pub_strOtherField = this.reportParameter.OtherField;
        }
        UserPreferencesObj.pub_blnSkipLinesBetweenStudent = this.reportParameter.SkipLineBetweenStudent;
        UserPreferencesObj.pub_blnPrintWithGreyHeadings = this.reportParameter.PrintWithGreyHeading;
        UserPreferencesObj.pub_blnPrintStudentAbsencesAlreadyEntered = this.reportParameter.PrintStudentAbsencesAlreadyEntered;
        UserPreferencesObj.pub_blnPrintTeacherSignatureLine = this.reportParameter.PrintTeacherSignatureLine;
        const xmlStream: string[] = [];
        xmlStream.push(JSON.stringify(UserPreferencesObj));
        this.userPreferencesService.saveUserPreferences(0, '/ManualEntryRosters.aspx', xmlStream, 0, '').subscribe(response => { }
            , err => {
                // On Error
                console.log(err);
            });
    }
    reportQueueList() {
        const reportQueueDialogRef = this.dialog.open(ReportQueueComponent, {
            panelClass: 'tyl-mat-dialog',
            disableClose: true,
        });
    }
} // end class